import {Cheese} from "@/util/CheeseService";

export type PlateList = Array<Plate>

export class Plate {
    id: number
    coding: number
    cheese: Cheese

    constructor(id: number, coding: number, cheese: Cheese) {
        this.id = id
        this.coding = coding
        this.cheese = cheese
    }
}
